import { apiClient, type ApiResponse } from '@/api';
import { WORKSPACE_API_URLS } from '@/api/constants/api.url';
import type { Workspace } from '@/modules/workspace/types';
import type { DevLoginResponse } from '@/modules/auth/types';

/**
 * Workspace service — the only file in the module that talks to axios.
 *
 * `switch` returns the same shape as a sign-in (`DevLoginResponse`): a fresh
 * token + tenant + plan + permissions scoped to the target workspace, which the
 * caller persists exactly like login before reloading.
 */
export const workspaceService = {
    async list(): Promise<Workspace[]> {
        const { data } = await apiClient.get<ApiResponse<{ workspaces: Workspace[] }>>(
            WORKSPACE_API_URLS.list,
        );
        return data.data.workspaces;
    },

    async switch(tenantId: string): Promise<DevLoginResponse> {
        const { data } = await apiClient.post<ApiResponse<DevLoginResponse>>(
            WORKSPACE_API_URLS.switch,
            { tenant_id: tenantId },
        );
        return data.data;
    },
};
